"use client";

import { useConsent } from "@/lib/consent-context";

export function VideoConsentGate({
  poster,
  className,
}: {
  poster?: string;
  className?: string;
}) {
  const { savePartial, openSettings } = useConsent();
  return (
    <div
      className={`relative size-full overflow-hidden bg-black ${className || ""}`}
    >
      {poster && (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={poster}
          alt=""
          aria-hidden
          className="absolute inset-0 size-full scale-105 object-cover opacity-25 blur-[2px]"
        />
      )}
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 p-6 text-center text-white">
        <p className="text-button max-w-[280px] text-white/90">
          This video is hosted on YouTube, which sets marketing cookies. Accept
          to watch it here.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <button
            type="button"
            onClick={() => savePartial({ marketing: true })}
            className="bg-purple-03 text-button rounded-full px-6 py-2.5 font-bold text-white transition-opacity hover:opacity-90"
          >
            Accept &amp; play
          </button>
          <button
            type="button"
            onClick={openSettings}
            className="text-button font-semibold text-white/70 underline underline-offset-4 transition-colors hover:text-white"
          >
            Manage cookies
          </button>
        </div>
      </div>
    </div>
  );
}
